// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2l4jl","modalFooterButton":"ModalNotes_modalFooterButton__1YyqN"};